import React from "react";
import { Box, Chip } from "@mui/material";
import styles from "./styles.module.css";
import { EditOutlined, EmojiEventsOutlined } from "@mui/icons-material";
import CoverImageUploader from "./cover-image-uploader";
import { useTheme } from "../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { updateSkillImageData } from "../../../../../store/slices/profile/skillImageSlice";

const SkillCoverImage = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { activeUserSkill } = useSelector((state) => state.user);

  return (
    <Box className={styles.skillsImg}>
      {activeUserSkill?.isEditorChoice && (
        <Chip
          label={"Creators' Choice"}
          variant="contained"
          icon={<EmojiEventsOutlined />}
          sx={{
            textTransform: "uppercase",
            padding: "6px 16px 6px 3px",
            gap: "14px",
            bgcolor: theme.palette.primary.main,
            color: "#FFF",
            "& svg": {
              color: "inherit !important",
            },
          }}
        />
      )}

      <Box
        className={styles.primaryImg}
        sx={{
          backgroundImage: activeUserSkill?.skillCoverImage
            ? `url(${activeUserSkill?.skillCoverImage})`
            : "none",
        }}
      >
        {!activeUserSkill?.skillCoverImage && <CoverImageUploader />}
        <Box className={styles.options}>
          {activeUserSkill?.isPrimary && (
            <>
              <Chip
                label="Primary Skill"
                sx={{
                  bgcolor: theme.palette.warning.main,
                  color: "#FFF",
                }}
              />
            </>
          )}
          {activeUserSkill?.acceptOnlyPaidProject && (
            <Chip
              label="Pro"
              sx={{
                bgcolor: theme.palette.warning.main,
                color: "#FFF",
              }}
            />
          )}
          {activeUserSkill?.skillCoverImage && (
            <Box
              className={styles.Cameraupload}
              onClick={() =>
                dispatch(updateSkillImageData({ isSkillImageModalOpen: true }))
              }
            >
              <EditOutlined
                fontSize="16px"
                sx={{ color: theme.palette.darkgrey.darkgrey400 }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SkillCoverImage;
